import { render } from "./LeadsClosedList.vue?vue&type=template&id=0fbb6a63"
import script from "./LeadsClosedList.vue?vue&type=script&lang=js"
export * from "./LeadsClosedList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__